// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_MigrarColaboradorInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/colaboradores/migrar
 * (controllers/migration/colaboradores.php::migrar).
 *
 * Um unico campo, obrigatorio: qual colaborador do Zoho migrar.
 *
 * ---------------------------------------------------------------------------
 * POR QUE `strictJsonTypes()` E TRUE AQUI — nao e preferencia de estilo
 * ---------------------------------------------------------------------------
 * O ID do Creator tem 19 digitos e e MAIOR que 2^53 (medido: armadilha A1 da
 * skill zoho-data-migration; o probe de 2026-08-18 confirmou sobre os BYTES que
 * o `id` do colaborador vem como NUMERO de 19 digitos). Um cliente que mandasse
 * `{"zoho_id": 45420...07}` como NUMERO JSON ja teria perdido digitos no
 * `JSON.stringify` do navegador — o valor que chega aqui e outro ID, nao o
 * pedido.
 *
 * Sem `strictJsonTypes()`, o `fill()` coagiria esse numero para string em
 * silencio e a migracao seguiria com o id errado. Na E2 isso e pior do que na
 * E1: o destino e o COGNITO, externo e sem transacao, e um id trocado nao
 * produz "unidade nao encontrada" — produz um usuario criado para a pessoa
 * errada, com a senha derivada da franquia errada. Com o contrato estrito, um
 * `zoho_id` que nao seja string e RECUSADO na validacao, que e o unico lugar
 * onde ainda da para consertar.
 */
import { registerContract } from './validate'

export interface Migration_MigrarColaboradorInput {
zoho_id: string
}

registerContract('Migration_MigrarColaboradorInput', {
  zoho_id: { type: 'string',  required: true },
})
